import {
  MAX_WORDMARK_CHARS,
  MAX_SLOGAN_CHARS,
} from '@/lib/constants/validators'

export default function({ store, query, $toast }) {
  let requires_refresh = false
  let redirect = false

  if (query.slogan) {
    if (query.slogan.length <= MAX_SLOGAN_CHARS) {
      if (query.slogan !== store.state.session.slogan) {
        requires_refresh = true
      }

      store.commit('session/setSlogan', query.slogan)
    } else {
      $toast.error(`Slogan must be less than ${MAX_SLOGAN_CHARS} letters.`)

      redirect = '/slogan'
    }
  }

  if (query.wordmark) {
    if (query.wordmark.length <= MAX_WORDMARK_CHARS) {
      if (query.wordmark !== store.state.session.wordmark) {
        requires_refresh = true
      }

      store.commit('session/setWordmark', query.wordmark)
    } else {
      $toast.error(
        `Business name must be less than ${MAX_WORDMARK_CHARS} letters.`
      )

      redirect = '/business-name'
    }
  }

  if (requires_refresh) {
    store.dispatch('app/refreshLogos')
  }

  if (redirect) {
    // client-side plugin redirect - https://nuxtjs.org/docs/2.x/internals-glossary/context#redirect
    window.onNuxtReady(() => window.$nuxt.$router.replace(redirect))
  }
}
